
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorDisplayProps {
  message: string;
  onRetry?: () => void;
  title?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ 
  message, 
  onRetry, 
  title = "Error" 
}) => {
  return (
    <div className="w-full my-4">
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-5 w-5 mr-2" />
        <div className="flex-1">
          <AlertTitle className="mb-1">{title}</AlertTitle>
          <AlertDescription>
            {message}
          </AlertDescription>
        </div>
      </Alert>
      
      {onRetry && (
        <div className="flex justify-center mt-2">
          <Button 
            variant="outline" 
            onClick={onRetry}
            className="flex items-center gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            Retry
          </Button>
        </div>
      )}
    </div>
  );
};

export default ErrorDisplay;
